export const getLocalId = (extensionId: string): string => {
	return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
